import { render, staticRenderFns } from "./brand.vue?vue&type=template&id=5f67632a&"
import script from "./brand.vue?vue&type=script&lang=js&"
export * from "./brand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f67632a')) {
      api.createRecord('5f67632a', component.options)
    } else {
      api.reload('5f67632a', component.options)
    }
    module.hot.accept("./brand.vue?vue&type=template&id=5f67632a&", function () {
      api.rerender('5f67632a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/data-dictionary/consumable-brands/brand.vue"
export default component.exports